import axios from 'axios';

/* NOTE(santeyio): if we need carrier specific script overrides
 * this logic will need to be rewritten to support
 * the new script format
const applyOverrides = (master, override) => {
  const overriddenMaster = master;
  Object.entries(override).forEach(([key, val]) => {
    Object.entries(val).forEach(([k, v]) => {
      overriddenMaster[key][k] = v;
    });
  });
  return overriddenMaster;
};

const applyPaths = (script, carrier, scriptYear) => {
  const updatedScript = {};
  Object.entries(script).forEach(([key, val]) => {
    updatedScript[`/${carrier}/${scriptYear}/${key}`] = val;
  });
  return updatedScript;
};

const parseScripts = (data, scriptYear) => {
  const {
    valid_carriers: carriers,
    script,
    carrier_script_overrides: overrides,
  } = data;

  let masterScript = {};

  carriers.forEach((carrier) => {
    let carrierScript = script;
    if (overrides[carrier]) {
      carrierScript = applyOverrides(script, overrides[carrier]);
    }

    carrierScript = applyPaths(carrierScript, carrier, scriptYear);

    masterScript = { ...masterScript, ...carrierScript };
  });

  return masterScript;
};
*/

export const loadScript = (scriptYear) => {
  const token = localStorage.getItem('SessionToken');

  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/config/scripts/${scriptYear}/`,
    headers: { Authorization: `Token ${token}` },
  })
    .then(({ data }) => data.script);
};
